import { useEffect, useState } from "react";
import { API_usuarios } from "../config/apiConfig";
import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  FaArrowRightToBracket,
  FaBriefcase,
  FaBell,
  FaCalendarDays,
  FaEnvelope,
  FaCodeBranch,
  FaHandHoldingHeart,
  FaUsers,
  FaRegCircleUser,
  FaChartLine,
  FaHouse,
  FaComment,
  FaUserGraduate,
  FaVideo,
  FaListCheck,
  FaDownload,
  FaBookOpen,
  FaGaugeHigh,
} from "react-icons/fa6";
import { useAuth } from "../context/AuthContext";
import { useNotificaciones } from "../context/NotificacionesContext";
import "./css/Navbar.css";
import Logo from "./Logo";
import MobileSideBar from "./MobileSideBar";
import HamburguerIcon from "./HamburguerIcon";
import useMediaQuery from "../hooks/unseMediaQuery";
import ProfileAuthMenu from "./navBar/ProfileAuthMenu";
import AdminMenuOptions from "./navBar/AdminMenuOptions";
import NotificationMenuOptions from "./navBar/NotificationMenuOptions";

const Navbar = ({
  onShowLoginForm,
  featuresRef = null,
  resourcesRef = null,
  downloadRef = null,
  onHandleVideoModal,
  onHandleLoginModalOpen,
  guestMenuHidden = false,
}) => {
  const auth = useSelector((state) => state.auth);
  const [isClosed, setIsClosed] = useState(true);
  const [shouldAnimate, setShouldAnimate] = useState(false);
  const { isAuthenticated, user, role } = auth || {};
  const { logout } = useAuth();
  const { token } = useAuth();
  const [userData, setUserData] = useState(null);
  const location = useLocation();

  const isSmallDevice = useMediaQuery("(max-width:1024px)");

  const technicalRoles = ["administrador", "tecnico-1", "tecnico-2"];

  const { hayPendientesExternos, hayCitasPendientes } = useNotificaciones(); // ✅ hook
  const mostrarAlertas = technicalRoles.includes(role) && (hayPendientesExternos || hayCitasPendientes);

  // Function to check if a path is active
  const isActivePath = (path) => {
    return location.pathname === path;
  };

  // Function to get active class name
  const getActiveClass = (path) => {
    return isActivePath(path) ? "opcion flex mayusculas activo" : "opcion flex mayusculas negro";
  };

  // Handle logout
  const handleLogout = async (e) => {
    e.preventDefault();
    try {
      await logout();
      // Optionally redirect to home page or login
      window.location.href = "/";
    } catch (error) {
      console.error("Error during logout:", error);
    }
  };

  // Handle opening the mobile sidebar
  const HandleOpenMenu = async () => {
    if (!isClosed) {
      setShouldAnimate(true);
      await new Promise((resolve) => setTimeout(resolve, 300)); // Wait for animation to finish
    }
    setIsClosed((prev) => !prev);
    setShouldAnimate(false);
  };

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const res = await fetch(`${API_usuarios}`, {
          headers: {
            // TODO: Replace with actual Auth token management
            "x-auth-token": token,
          },
        });
        const data = await res.json();

        const matchedUser = data.find((u) => {
          const emailMatch = user?.email && u.email === user.email;
          const nameAndRoleMatch = u.name?.toLowerCase() === user?.name?.toLowerCase() && u.role === role;
          return emailMatch || nameAndRoleMatch;
        });

        setUserData(matchedUser);
      } catch (error) {
        console.error("Error al cargar datos del usuario:", error);
      }
    };

    if (isAuthenticated && user && role) {
      fetchUserData();
    }
  }, [user, role, isAuthenticated]);

  return (
    <nav className={`menu fixed fondo-blanco w-100 ${!isAuthenticated ? " guest" : ""}`}>
      <div className="menu-wrapper-inner main-container-wrapper">
        {/* CIUDADANO */}
        {isAuthenticated && role === "ciudadano" && (
          <div className="menuUsuario between">
            <Logo />
            <div className="perfil align-center">
              <p className="text-right">
                <span className="verde bold">{userData?.name || user?.name}</span>
                <br />
                {userData?.lastName || user?.lastName}
              </p>
              <Link to="/perfil" aria-label="Mi perfil" className={isActivePath("/perfil") ? "activo" : "negro"}>
                <FaRegCircleUser />
              </Link>
              <button
                onClick={handleLogout}
                aria-label="Cerrar sesión"
                className="negro logout-btn"
                style={{
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                }}
              >
                <FaArrowRightToBracket />
              </button>
            </div>
          </div>
        )}

        {/* TÉCNICOS */}
        {(location.pathname.startsWith("/admin") ||
          location.pathname.startsWith("/empleo") ||
          location.pathname.startsWith("/formacion") ||
          location.pathname.startsWith("/recurso") ||
          location.pathname.startsWith("/recurso-social")) &&
          isAuthenticated &&
          technicalRoles.includes(role) && (
            <>
              <div className="menuTecnico main-container-wrapper between">
                <Logo />
                <ProfileAuthMenu userData={userData} onHandleLogout={handleLogout} isActivePath={isActivePath} role={role} user={user} />
              </div>
              <div className="main-menu-border">
                <div className="submenuTecnico main-container-wrapper between">
                  <div className="opciones between">
                    <AdminMenuOptions isActivePath={isActivePath} />
                  </div>

                  <div className="iconosMenu align-center">
                    <NotificationMenuOptions mostrarAlertas={mostrarAlertas} isActivePath={isActivePath} />
                  </div>
                </div>
              </div>
            </>
          )}

        {/* GUEST */}
   {(
  !location.pathname.startsWith("/admin") &&
  !location.pathname.startsWith("/empleo") &&
  !location.pathname.startsWith("/formacion") &&
  !location.pathname.startsWith("/recurso-social") &&
  !location.pathname.startsWith("/recurso")
) && (
            <>
              <div className="menuLanding between">
                <Logo />
                <div className="botones align-center z-[90]">
                  {isSmallDevice && <HamburguerIcon shouldAnimate={shouldAnimate} isClosed={isClosed} onHandleOpenMenu={HandleOpenMenu} />}
                  {!isAuthenticated && !isSmallDevice && (
                    <>
                      <Link to="/registro" className="registro">
                        Registrarme
                      </Link>
                      <button onClick={onShowLoginForm} className="inicio verde">
                        Iniciar sesión
                      </button>
                    </>
                  )}
                  {isAuthenticated && technicalRoles.includes(role) && !isSmallDevice && (
                    <ProfileAuthMenu
                      userData={userData}
                      onHandleLogout={handleLogout}
                      isActivePath={isActivePath}
                      role={role}
                      user={user}
                    />
                  )}
                </div>
              </div>
              {!isSmallDevice && (
                <div className="submenuTecnico between main-menu-border">
                  <div className="opciones between">
                    {isAuthenticated && technicalRoles.includes(role) && (
                      <Link
                        to="/admin/dashboard"
                        className={`opcion flex uppercase text-sm 2xl:text-base ${isActivePath("/admin/dashboard") ? "activo" : "negro"}`}
                      >
                        <FaGaugeHigh className="text-base 2xl:text-xl" />
                        Panel de Administración
                      </Link>
                    )}
                    {!guestMenuHidden && (
                      <>
                        <button onClick={onHandleVideoModal} className="opcion flex text-sm 2xl:text-base">
                          <FaVideo className="text-base 2xl:text-xl" />
                          VER DEMOSTRACIÓN
                        </button>

                        <button
                          className="opcion flex text-sm 2xl:text-base"
                          onClick={() => {
                            featuresRef?.current?.scrollIntoView({
                              behavior: "smooth",
                              block: "center",
                            });
                          }}
                        >
                          <FaListCheck className="text-base 2xl:text-xl" />
                          CARACTERÍSTICAS
                        </button>

                        <button
                          className="opcion flex text-sm 2xl:text-base"
                          onClick={() => {
                            resourcesRef?.current?.scrollIntoView({
                              behavior: "smooth",
                              block: "center",
                            });
                          }}
                        >
                          <FaBookOpen className="text-base 2xl:text-xl" />
                          MAPA DE RECURSOS
                        </button>

                        <button
                          className="opcion flex text-sm 2xl:text-base"
                          onClick={() => {
                            downloadRef?.current?.scrollIntoView({
                              behavior: "smooth",
                              block: "center",
                            });
                          }}
                        >
                          <FaDownload className="text-base 2xl:text-xl" />
                          DESCARGA Y CONTACTO
                        </button>
                      </>
                    )}
                  </div>
                  <div className="iconosMenu align-center">
                    {isAuthenticated && technicalRoles.includes(role) && (
                      <NotificationMenuOptions mostrarAlertas={mostrarAlertas} isActivePath={isActivePath} />
                    )}
                  </div>
                </div>
              )}

              {!isClosed && isSmallDevice && (
                <MobileSideBar
                  onHandleVideoModal={onHandleVideoModal}
                  featuresRef={featuresRef}
                  resourcesRef={resourcesRef}
                  downloadRef={downloadRef}
                  onClose={() => setIsClosed(true)}
                  isClosed={isClosed}
                  shouldAnimate={shouldAnimate}
                  onHandleLoginModalOpen={onHandleLoginModalOpen}
                  technicalRoles={technicalRoles}
                />
              )}
            </>
          )}
      </div>
    </nav>
  );
};

export default Navbar;
